import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutCartIsValidatedGuard implements CanActivate {
  constructor(
    protected routingService: RoutingService,
    protected activeCartService: ActiveCartService,
    protected cartExtendService: CartExtendService,
    protected componentService: ComponentService
  ) {}

  canActivate(): Observable<boolean> {
    return this.activeCartService.getActiveCartId().pipe(
      mergeMap((cartId) => this.cartExtendService.getCurrentCartByID(cartId)),
      map((cart: any) => {
        if (!cart.validated) {
          this.routingService.go({ cxRoute: 'cart' });
          return false;
        }
        this.componentService.checkoutCartEntries$.next(cart);
        this.componentService.checkoutCartEntriesPaymentAddress$.next(cart.paymentAddress);
        this.componentService.checkoutCartEntriesOrderType$.next(cart.orderType);
        return true;
      })
    );
  }
}
